import { createSlice } from "@reduxjs/toolkit";
import { getData } from "../core/fetchService";

export const lookup = createSlice({
  name: "lookup",
  initialState: {
    entities: null,
    currentEntity: null,
    currentValues: null,
  },
  reducers: {
    setEntities: (state, action) => {
      state.entities = action.payload;
    },
    setCurrentEntity: (state, action) => {
      state.currentEntity = action.payload;
    },
    setCurrentValues: (state, action) => {
      state.currentValues = action.payload;
    },
  },
});

export const {
  setEntities,
  setCurrentValues,
  setCurrentEntity,
} = lookup.actions;

// not used
// export const getEntities = (state) => state.lookup.entities;

export const getCurrentEntity = (state) => state.lookup.currentEntity;

export const getValues = (state) => state.lookup.currentValues;

export default lookup.reducer;

export const fetchAllEntities = (obj) => (dispatch) => {
  const { projectId } = obj;
  getData(`/api/lookup?project=${projectId}`, dispatch, (data) => {
    dispatch(setEntities(data.lookups));
  });
};

export const fetchValuesById = (id, restFn = () => null) => (dispatch) => {
  getData(`/api/lookup/entity/value?_id=${id}`, dispatch, (data) => {
    dispatch(setCurrentValues(data.values));
    restFn();
  });
};

export const fetchValuesForSearch = (
  page,
  search,
  currentEntity,
  currentValues
) => (dispatch) => {
  getData(
    `/api/lookup/entity/value?_id=${
      currentEntity._id
    }&page=${page}&search=${search}`,
    dispatch,
    (data) => {
      dispatch(setCurrentValues(search && page === 0 ? [...data.values] : [...currentValues, ...data.values]));
    }
  );
};
